import { Component } from '@angular/core';
import { TlnInfoComponent } from '../tln-info/tln-info.component';
import { WildflowerInfoComponent } from '../wildflower-info/wildflower-info.component';


@Component({
  standalone: true,
  selector: 'app-breastfeeding',
  templateUrl: './breastfeeding.component.html',
  styleUrls: ['./breastfeeding.component.css'],
  imports: [
    TlnInfoComponent,
    WildflowerInfoComponent
  ]
})
export class BreastfeedingComponent {

}
